import { gql } from "@apollo/client";

const deal = `
  _id
  campaignType
  buyerId
  buyer {
    name
  }
  advertiserId
  advertiser {
    name
  }
  websiteIds
  websites {
    _id
    name
  }
  platformDiscount
  status
  revenue
  campaignCreationLink
  createdAt
  creatorId
`;

export const GET_DEALS = gql`
  query DealMany($page: Int, $perPage: Int, $filters: DealFilterArgs, $sort: SortInput) {
    deals: DealMany(page: $page, perPage: $perPage, filters: $filters, sort: $sort) {
      items {
        ${deal}
      }
      meta {
        totalItems
      }
    }
  }
`;

export const GET_DEAL_BY_ID = gql`
  query DealById($id: ObjectId!) {
    deal: DealById(_id: $id) {
      _id
      campaignType
      advertiserId
      advertiser {
        name
      }
      websiteIds
      websites {
        _id
        name
      }
      platformDiscount
      status
      campaignId
    }
  }
`;

export const CREATE_DEAL = gql`
  mutation DealCreateOne($record: CreateDealInput!) {
    DealCreateOne(record: $record) {
      ${deal}
    }
  }
`;
